import { Flex, Input, Text, Box } from '@chakra-ui/react'

export const Card = ({ label, value, border = true, bold = false, pedidoFornecedor = false, register, errors }) => {
  return (
    <Box>
      <Flex alignItems="center" gap=".6rem" border={border ? '1px solid #ccc' : 'none'} px="1rem" py=".5rem">
        <Text color="#378BBF" fontWeight={bold ? 'bold' : 'normal'}>
          {label}:{' '}
        </Text>{' '}
        {pedidoFornecedor ? (
          <Input
            maxW="7.5rem"
            borderColor={errors?.pedidoFornecedor ? 'red.500' : '#ccc'}
            {...register('pedidoFornecedor')}
            placeholder="Digite..."
            _placeholder={{ fontSize: '15px' }}
          />
        ) : (
          <Text fontWeight={bold ? 'bold' : 'normal'}>{value}</Text>
        )}
      </Flex>
      {pedidoFornecedor && errors?.pedidoFornecedor && (
        <Text color="red.500" fontSize="xs" ml="1rem" mt="-0.2rem" mb="0.2rem">
          {errors.pedidoFornecedor.message}
        </Text>
      )}
    </Box>
  )
}
